// src/components/ContactForm/ContactForm.jsx
import React, { useState } from 'react';
import './ContactForm.css';

const ContactForm = ({ title = "Get A Quote", showDescription = true }) => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });

    const [status, setStatus] = useState({
        submitting: false,
        type: null,
        message: null
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus({ submitting: true, type: null, message: null });

        try {
            const response = await fetch('/mail.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const contentType = response.headers.get("content-type");
            if (!contentType || !contentType.includes("application/json")) {
                const text = await response.text();
                console.error("Non-JSON Response:", text);
                throw new Error(`Server Error ${response.status}: ${response.statusText}. (See console for details)`);
            }

            const result = await response.json();

            if (response.ok) {
                setStatus({ type: 'success', message: result.message });
                setFormData({ name: '', email: '', phone: '', message: '' });
                const checkbox = document.getElementById('termsCheck');
                if (checkbox) checkbox.checked = false;
            } else {
                setStatus({ type: 'error', message: result.message || 'Something went wrong.' });
            }
        } catch (error) {
            console.error("Form Submission Error:", error);
            setStatus({ type: 'error', message: `Submission Failed: ${error.message}` });
        } finally {
            setStatus(prev => ({ ...prev, submitting: false }));
        }
    };

    return (
        <div className="contact-form-wrapper">
            <h3 className="fw-bold mb-2">{title}</h3>
            {showDescription && (
                <p className="text-muted small mb-4">
                    Your email address will not be published. Required fields are marked.
                </p>
            )}

            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <input
                        type="text"
                        className="form-control form-control-custom"
                        placeholder="Your Name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="mb-3">
                    <input
                        type="email"
                        className="form-control form-control-custom"
                        placeholder="Email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="mb-3">
                    <input
                        type="tel"
                        className="form-control form-control-custom"
                        placeholder="Enter number"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                    />
                </div>
                <div className="mb-3">
                    <textarea
                        className="form-control form-control-custom"
                        rows="4"
                        placeholder="Write a message..."
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                    ></textarea>
                </div>

                <div className="form-check mb-4">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id="termsCheck"
                        required
                    />
                    <label className="form-check-label small text-muted" htmlFor="termsCheck">
                        I accept terms and privacy policy.
                    </label>
                </div>

                {status.message && (
                    <div className={`alert ${status.type === 'success' ? 'alert-success' : 'alert-danger'} mb-3`}>
                        {status.message}
                    </div>
                )}

                <button type="submit" className="btn btn-message w-100" style={{ backgroundColor: "#EF6C00", color: "white" }} disabled={status.submitting}>
                    {status.submitting ? 'Sending...' : 'Send Message'}
                </button>
            </form>
        </div>
    );
};

export default ContactForm;
